import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import { WithStyles } from '@material-ui/core';
import { generateStyle } from '../utils/styles';
import Style from './style';
import Page404 from '../Page/Page404';
import HomePage from '../Page/HomePage';
import PreLoginPage from '../Page/PreLoginPage';
import PrivacyPolicyPage from '../Page/PrivacyPolicyPage';
import TnCPage from '../Page/TnCPage';
import PageEmail from '../Page/PageEmail';

interface Props extends WithStyles<typeof Style> {
	[name: string]: any;
}

const App: React.FC<Props> = ({ classes }: Props) => {
	return (
		<div className={classes.root}>
			<Router>
				<Routes>
					<Route path="/" element={<PreLoginPage />} />
					<Route path="/login" element={<HomePage />} />
					<Route path="/auth" element={<HomePage />} />
					<Route path="/error" element={<Page404 />} />
					<Route path="/pinreset" element={<PageEmail />} />
					<Route path="/privacy-policy" element={<PrivacyPolicyPage />} />
					<Route path="/terms-of-service" element={<TnCPage />} />
					<Route path="*" element={<Page404 />} />
				</Routes>
			</Router>
		</div>
	);
};

export default generateStyle(Style, 'App')(App);
